import React from 'react'

const EmailFooter = () => {
    return (
        <div className="container">

            <div class="footer">
                <p>
                    Value Added Coating Solution Private Limited<br />
                    Email: <a href="mailto:info@coating-solution.com">info@coating-solution.com</a><br />
                    Head Office: 515, Devika Tower, Chandra Nagar, Ghaziabad, U.P.<br />
                    Work/Lab/R&D Center: K-288, Q-21 (GF & FF), Site-V, Surajpur Industrial Area, Kasna, Greater Noida - 201306<br />
                    Websites: <a href="http://optifinish.in/" rel="noreferrer">http://optifinish.in</a> | <a href="https://www.coating-solution.com/">https://www.coating-solution.com/</a>
                </p>
                <div class="social-links">
                    <a href="https://www.facebook.com/vacspl.official" target="_blank" rel="noreferrer">Facebook</a> |
                    <a href="https://www.youtube.com/@vacspl/videos" target="_blank" rel="noreferrer">YouTube</a> |
                    <a href="https://www.instagram.com/vacspl/" target="_blank" rel="noreferrer">Instagram</a> |
                    <a href="https://www.instagram.com/vacspl/" target="_blank" rel="noreferrer">Twitter</a>
                </div>
            </div>
        </div>
    )
}

export default EmailFooter